<template>
    <navbar :showReg="false" :showLogin="true" :showItems="false" :showComunity="false" :showName="true"></navbar>
    <div id="publishTherapy">  
        <section id="hero-area" class="section hero-section1">
            <div class="overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="hero-content-wrap mt-4">
                            <div class="hero-content typed-strings" v-if="userLogoRectangle == '' && userLogoSquare == ''">
                                <img :src="profImg" class="img-user mb-2" />
                                <h4 v-if="bussinessName == ''" class="text-white fw-light">{{ profName }} {{ profLastName }}</h4>
                                <h4 v-else class="text-white fw-light">{{ bussinessName }}</h4>
                            </div>
                            <div class="hero-content typed-strings" v-else>
                                <img v-if="userLogoRectangle != ''" :src="userLogoRectangle" class="img-logo-rectangle mb-2" />
                                <img v-else :src="userLogoSquare" class="img-logo-square mb-2" />
                                <h4 v-if="bussinessName == ''" class="text-white fw-light">{{ profName }} {{ profLastName }}</h4>
                                <h4 v-else class="text-white fw-light">{{ bussinessName }}</h4>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        </section>
        <section class="mt-5">
            <div class="container result-search" style="min-height: auto !important;">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section-title text-center" v-if="arrayResTherapies.length > 0">
                            <h3 class="fw-light section-title">Servicios</h3>
                        </div>
                        <div v-if="arrayResTherapies.length > 0" class="results-c w-100 mt-2 mb-0">
                            <div>
                                <div class="card mt-2" v-for="p in arrayResTherapies" :key="p.id">
                                    <a target="_parent" class="btn-more-info" :href="baseUrl + 'service-landing/' + p.linkId + '/' + p.link" style="text-decoration: none; color: inherit;">
                                    <div class="card-body p-2">
                                        <div class="d-block d-sm-flex justify-content-between align-items-center w-100">
                                            <div class="row row-eq-height w-100">
                                                <div class="col-sm-12 col-md-7">
                                                    <div class="d-flex align-items-center">
                                                        <div class=" img-container">
                                                            <div class="d-flex align-items-center h-100" v-if="p.images.length > 0">
                                                                  <img v-if="p.images[0].link != '@/assets/imgs/user-img-small.png'" :src="p.images[0].link" class="img-fluid" />
                                                                  <img v-else src="@/assets/imgs/no-publish-img.png" class="img-fluid" /> 
                                                              </div>
                                                              <div class="d-flex align-items-center h-100" v-else>
                                                                  <img src="@/assets/imgs/no-publish-img.png" class="img-fluid" /> 
                                                              </div>
                                                        </div>
                                                        <div>
                                                            <h6 class="therapy-name mb-0 text-dark">{{ p.title }}</h6>
                                                            <p class="small" v-if="p.therapyId != 0">{{ p.therapy }}</p>
                                                            <p class="small" v-else>{{ p.therapyOther }}</p>
                                                            <!--<h5 class="title">
                                                                <img v-if="p.userCountryId == 5" src="@/assets/imgs/flags/ar.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 42" src="@/assets/imgs/flags/mx.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 81" src="@/assets/imgs/flags/cl.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 55" src="@/assets/imgs/flags/us.png" class="flag" />
                                                                <img v-else-if="p.userCountryId == 28" src="@/assets/imgs/flags/es.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 89" src="@/assets/imgs/flags/pe.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 82" src="@/assets/imgs/flags/co.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 111" src="@/assets/imgs/flags/uy.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 12" src="@/assets/imgs/flags/br.png" class="flag" />  
                                                                <img v-else-if="p.userCountryId == 103" src="@/assets/imgs/flags/ec.png" class="flag" />  
                                                                <img v-else src="@/assets/imgs/flags/la.png" class="flag" /> 
                                                                {{ p.profName }}
                                                            </h5>-->
                                                            <!--<p class="text-success m-0"><b>¡Turnos disponibles para hoy!</b></p>-->
                                                            <small class="text-muted" v-if ="p.typeTurn == 0">Turnos: {{ p.days }}</small>  
                                                            <small class="text-muted" v-if ="p.typeTurn == 1">Fechas y horarios limitados</small>  
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-5">
                                                    <div class="details h-100">              
                                                        <div class="row h-100">
                                                            <div>
                                                                <span v-if="p.modalityId == 1" class="status active">{{ p.modality }}</span> 
                                                                <span v-if="p.modalityId == 2" class="status paused">{{ p.modality }}</span> 
                                                                <span v-if="p.modalityId == 3" class="status paused">{{ p.modality }}</span> 
                                                                <span class=""><i class="lar la-clock text-success"></i> {{ p.duration }}min.</span>
                                                            </div>
                                                            <div class="col-8 col-md-8">     
                                                                <div class="d-flex align-items-center h-100" v-if="p.hidePrice == 0 && p.noPrice == 0">
                                                                    <div v-if="p.free == 0">
                                                                        <p v-if="p.praConsulta == 1 && p.promo == 0" class="text-success legend">Descuento en primera consulta</p> 
                                                                        <p v-if="p.promo == 1" class="text-success legend">Precio promocional por tiempo limitado</p>
                                                                        <div v-if="p.praConsulta == 0 && p.promo == 0">
                                                                            <p v-if="p.priceConverted == false" class="price">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <div v-if="p.qtySessions > 1"><span class="badge rounded-pill bg-info m-2"><i class="las la-project-diagram"></i>Valor x {{ p.qtySessions }} Sesiones</span></div>
                                                                        </div>
                                                                        <div v-if="p.praConsulta == 1 && p.promo == 0">
                                                                            <p v-if="p.priceConverted == false" class="price old">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price old">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == false" class="price">{{ p.moneda }} {{ p.showPriceUserFirst }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price">{{ p.moneda }} {{ p.showPriceUserFirst }}</p>
                                                                            <div v-if="p.qtySessions > 1"><span class="badge rounded-pill bg-info m-2"><i class="las la-project-diagram"></i>Valor x {{ p.qtySessions }} Sesiones</span></div>
                                                                        </div>
                                                                        <div v-if="p.promo == 1">
                                                                            <p v-if="p.priceConverted == false" class="price old">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price old">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == false" class="price">{{ p.moneda }} {{ p.showPriceUserPromo }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price">{{ p.moneda }} {{ p.showPriceUserPromo }}</p>
                                                                            <div v-if="p.qtySessions > 1"><span class="badge rounded-pill bg-info m-2"><i class="las la-project-diagram"></i>Valor x {{ p.qtySessions }} Sesiones</span></div>
                                                                        </div>   
                                                                    </div>
                                                                    <div v-else>
                                                                        <p class="price">GRATUITO</p>
                                                                        <div v-if="p.qtySessions > 1"><span class="badge rounded-pill bg-info m-2"><i class="las la-project-diagram"></i>Valor x {{ p.qtySessions }} Sesiones</span></div>
                                                                    </div>
                                                                   
                                                                </div>

                                                            </div>
                                                            <div class="col-4 col-md-4">
                                                                <div class="d-flex align-items-center justify-content-center h-100">
                                                                    <div class="text-center">
                                                                        <a target="_parent" class="btn-more-info" :href="baseUrl + 'service-landing/' + p.linkId + '/' + p.link">Ver más</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>  
                                </a>
                                </div> 
                                <div v-if="fromResult < totalResult" class="text-center mt-3">
                                    <button class="btn btn-sm btn-primary" @click="getMoreResult(this.searchTerm, this.typeSerch)">Cargar más</button>
                                </div>
                            </div>
                        </div>
                        <div class="section-title text-center mt-5" v-if="arrayResCourse.length > 0">
                            <h3 class="fw-light section-title">Talleres / Cursos</h3>
                        </div>
                        <div v-if="arrayResCourse.length > 0" class="results-c w-100 mt-2 mb-0">
                            <div>
                                <div class="card mt-2" v-for="p in arrayResCourse" :key="p.id">
                                    <a target="_parent" class="btn-more-info" :href="baseUrl + 'course-landing/' + p.linkId + '/' + p.link" style="text-decoration: none; color: inherit;">
                                    <div class="card-body p-2">
                                        <div class="d-block d-sm-flex justify-content-between align-items-center w-100">
                                            <div class="row row-eq-height w-100">
                                                <div class="col-sm-12 col-md-7">
                                                    <div class="d-flex align-items-center">
                                                        <div class=" img-container">
                                                            <div class="d-flex align-items-center h-100" v-if="p.images.length > 0">
                                                                <img v-if="p.images[0].link != '@/assets/imgs/user-img-small.png'" :src="p.images[0].link" class="img-fluid" />
                                                                <img v-else src="@/assets/imgs/no-publish-img.png" class="img-fluid" /> 
                                                            </div>
                                                            <div class="d-flex align-items-center h-100" v-else>
                                                                <img src="@/assets/imgs/no-publish-img.png" class="img-fluid" /> 
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <h6 class="therapy-name mb-0 text-dark">{{ p.title }}</h6>
                                                            <!--<h5 class="title">
                                                                <img v-if="p.userCountryId == 5" src="@/assets/imgs/flags/ar.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 42" src="@/assets/imgs/flags/mx.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 81" src="@/assets/imgs/flags/cl.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 55" src="@/assets/imgs/flags/us.png" class="flag" />
                                                                <img v-else-if="p.userCountryId == 28" src="@/assets/imgs/flags/es.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 89" src="@/assets/imgs/flags/pe.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 82" src="@/assets/imgs/flags/co.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 111" src="@/assets/imgs/flags/uy.png" class="flag" /> 
                                                                <img v-else-if="p.userCountryId == 12" src="@/assets/imgs/flags/br.png" class="flag" />  
                                                                <img v-else-if="p.userCountryId == 103" src="@/assets/imgs/flags/ec.png" class="flag" />  
                                                                <img v-else src="@/assets/imgs/flags/la.png" class="flag" /> 
                                                                {{ p.profName }}
                                                            </h5>-->
                                                            <p class="text-success m-0" v-if="p.certificate == 2"><b>Entrega Certificado al finalizar</b></p> 
                                                            
                                                        </div>
                                                    </div>
                                                    <div> 
                                                        <hr class="mt-0">
                                                        <small>{{p.shortDescription}}</small> 
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-5">
                                                    <div class="details h-100">              
                                                        <div class="row h-100">
                                                            <div>
                                                                <span v-for="c in p.category" :key="c.id" class="status active">{{ c.name }}</span>   
                                                            </div>
                                                            <div> 
                                                                <span class="legend"><i class="lar la-clock text-success"></i> Duración total: {{ p.duration }}min.</span>
                                                            </div>
                                                            <div class="col-8 col-md-8">    
                                                                
                                                                <div class="d-flex align-items-center h-100">    
                                                                    <div v-if="p.free == 0">
                                                                        <p class="text-success m-0 legend" v-if="p.firstModuleFree == 1"><b>¡Primer modulo Gratis!</b></p>   
                                                                        <p v-if="p.promo == 1" class="text-success legend">Precio promocional por tiempo limitado</p>
                                                                        <div v-if="p.praConsulta == 0 && p.promo == 0">
                                                                            <p v-if="p.priceConverted == false" class="price">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                        </div>
                                                                        <div v-if="p.promo == 1">
                                                                            <p v-if="p.priceConverted == false" class="price old">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price old">{{ p.moneda }} {{ p.showPriceUserReal }}</p>
                                                                            <p v-if="p.priceConverted == false" class="price">{{ p.moneda }} {{ p.showPriceUserPromo }}</p>
                                                                            <p v-if="p.priceConverted == true" class="price">{{ p.moneda }} {{ p.showPriceUserPromo }}</p>
                                                                        </div>   
                                                                    </div>
                                                                    <div v-else>
                                                                        <p class="text-success m-0 legend" v-if="p.firstModuleFree == 1"><b>¡Primer modulo Gratis!</b></p>   
                                                                        <p class="price">GRATUITO</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-4 col-md-4">
                                                                <div class="d-flex align-items-center justify-content-center h-100">
                                                                    <div class="text-center">
                                                                        <a target="_parent" class="btn-more-info" :href="baseUrl + 'course-landing/' + p.linkId + '/' + p.link">Ver más</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>  
                                </a>
                                </div> 
                                <div v-if="fromResultCourse < totalResultCourse" class="text-center mt-3">
                                    <button class="btn btn-sm btn-primary" @click="getMoreResult(this.searchTerm, this.typeSerch)">Cargar más</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>    
        <section id="bio" class="mt-5" v-if="infoBio != ''">
            <div class="container bio">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section-title text-center">
                            <img :src="profImg" class="img-user" style="transform: inherit;" />
                            <h3 class="fw-light section-title">Más sobre {{ profName }} {{ profLastName }}</h3>
                        </div>
                        <div v-html="infoBio"></div>    
                    </div>
                </div>
            </div>
        </section>   
        <section class="mt-5 mb-5 pb-5">
            <div class="container bio" v-if="userFacebook != '' || userInstagram != '' || userLinkedIn != '' || userTwitter != '' || userTikTok != '' || userYouTube != '' || userTwitch != '' || userWeb != '' || mailCheck == '1' || addressCheck == '1'">
                <div class="row">
                    <div class="col-md-12 text-center" v-if="userFacebook != '' || userInstagram != '' || userLinkedIn != '' || userTwitter != '' || userTikTok != '' || userYouTube != '' || userTwitch != '' || userWeb != ''">
                        <div class="section-title text-center"> 
                            <h3 class="fw-light section-title">Página web y redes sociales</h3>
                        </div>
                        <div v-if="userWeb != ''" class="mb-3 text-truncate">
                            <p class="m-0">Visitar sitio:</p>
                            <a v-if="userWeb != ''" target="blank" :href="userWeb" title="Visitar perfil web">{{ userWeb }}</a>
                        </div>    
                    </div>
                    <div class="col-md-12 text-center" v-if="userFacebook != '' || userInstagram != '' || userLinkedIn != '' || userTwitter != '' || userTikTok != '' || userYouTube != '' || userTwitch != '' || userWeb != ''">
                        <p class="m-0">Visitar perfil en:</p>
                        <a v-if="userFacebook != ''" class="btn btn-secondary user-social" target="blank" :href="userFacebook" title="Visitar perfil de Facebook"><i class="lab la-facebook-f"></i></a>
                        <a v-if="userInstagram != ''" class="btn btn-secondary user-social" target="blank" :href="userInstagram" title="Visitar perfil de Instagram"><i class="lab la-instagram"></i></a>
                        <a v-if="userLinkedIn != ''" class="btn btn-secondary user-social" target="blank" :href="userLinkedIn" title="Visitar perfil de LinkedIn"><i class="lab la-linkedin-in"></i></a>
                        <a v-if="userTwitter != ''" class="btn btn-secondary user-social" target="blank" :href="userTwitter" title="Visitar perfil de X (Twitter)"><img src="@/assets/imgs/twitter-x.svg" class="img-fluid" style="width: 13px; margin-top: -3px; filter: invert(1);"></a> 
                        <a v-if="userYouTube != ''" class="btn btn-secondary user-social" target="blank" :href="userYouTube" title="Visitar perfil de YouTube"><i class="lab la-youtube"></i></a>
                        <a v-if="userTwitch != ''" class="btn btn-secondary user-social" target="blank" :href="userTwitch" title="Visitar perfil de Twitch"><i class="lab la-twitch"></i></a>
                        <a v-if="userTikTok != ''" class="btn btn-secondary user-social" target="blank" :href="userTikTok" title="Visitar perfil de TikTok"><img src="@/assets/imgs/tiktok-icon.png" class="img-fluid" style="width: 13px; margin-top: -3px; filter: invert(1);"></a> 
                    </div>
                    <a class="text-center mt-3" v-if="mailCheck == '1'" target="blank" :href="'mailto:'+ userMail">{{ userMail }}</a>
                    <p class="text-center mt-3" v-if="addressCheck == '1'"><i class="las la-map-marker-alt"></i> <span v-if="userStreet != ''" v-html="userStreet"></span> <span v-if="userFloor != ''" v-html="userFloor"></span> <span v-if="userDepto != ''" v-html="userDepto"></span> <span v-if="userCity != ''" v-html="userCity"></span> <span v-if="userState != ''" v-html="userState"></span> <span v-if="userCountry != ''" v-html="userCountry"></span></p>
                </div>
            </div>
        </section>    
    </div>

     <!-- wa -->
     <div class="wa-container" >
        <div class="lbvXTF" v-if="btnWa && phoneCheck == '1'">
            <button role="button" tabindex="0" class="gnjhpp euBiGU" type="button" @click="openWa()">
                <span class="cjTloD">
                    <div class="gMSomS">
                        <div>
                            <div>
                                <i class="lab la-whatsapp"></i>
                            </div>
                        </div>
                    </div>
                    <span class="dqiKFy">
                        
                        <span class=""></span>
                    </span>
                </span>
            </button>
        </div>
        <div class="jLHpcH" v-if="btnWa && phoneCheck == '1'">
            <div :class="waOpenClose">
                <div class="bqmPag text-center">
                    <div role="button" tabindex="0" class="bHDPhi" @click="closeWa()"></div>
                    <div class="fwCjK text-start">
                        <div class="fSqrexkFAyCA">
                            <div class="gJOYgw"><img v-if="profImg != ''" :src="profImg" class="UobXQ"><img v-else src="@/assets/imgs/logo-form-empresas.png" class="UobXQ"></div>
                        </div>
                        <div class="kRqifD">
                            <div class="hgwDJP">{{ profName }}</div>
                            <!--<div class="Header__AnswerTime-sc-5nh99s-3 coXmzM">Typically replies within a day</div>-->
                        </div>
                    </div>
                    <div class="czJZmb text-start">
                        <div class="chJVkN">
                            <div class="dcUHJP" :class="waDots">
                                <div class="ZSLkz">
                                    <div class="iAzjNW eoQXKa"></div>
                                    <div class="iAzjNW jVsCox"></div>
                                    <div class="iAzjNW gRVhYZ"></div>
                                </div>
                            </div>
                            <div class="drCIHo" :class="waMessage">
                                <div class="TZMBk">{{ profName }}</div>
                                <div class="fPKXxD">
                                    <div>Hola 👋</div>
                                    <br>
                                    <div>Si tienes dudas y necesitas ayuda puedes consultarme!!!</div>
                                </div>
                                <div class="TGVsQ">{{timeWa}}</div>
                            </div>
                        </div>
                    </div>

                    <a target="blank" title="WhatsApp" :href="'https://api.whatsapp.com/send?phone=' + userPhone" class="euBiGU hnfPJG m-1 w-75" type="button" tabindex="0">
                        <span class="cjTloD">
                            
                            <span class="dqiKFy">ABRIR CHAT</span>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>


    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 11000; width: fit-content;">
        <div id="toastcontainer" class="w-25">
        </div>
    </div>
</template>
<script>

import navbar from '@/components/nav/navbar-publications.vue'
import axios from "axios";
import { Toast } from 'bootstrap'
export default { 
    name: "myTools",
    components: {
        navbar
    }, 
    data(){
        return{ 
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,     
            ref: '',
            arrayResTherapies: [],
            arrayResCourse: [],
            profRef: '',
            profName: '',
            profLastName: '',
            profImg: '',
            infoBio: '', 
            twitterLink: '',
            facebookLink: '',
            whatsappLink: '',
            showLogo: false,   
            userFacebook: '',
            userInstagram: '',
            userLinkedIn: '',
            userTwitter: '',
            userTikTok: '',
            userYouTube: '',
            userTwitch: '',
            userWeb: '',
            fromResult: 0,
            fromResultCourse: 0,
            totalResult: 0,
            totalResultCourse: 0,

            phoneCheck: false,
            mailCheck: false,
            addressCheck: false,
            userMail: '',
            phoneInput: '',
            phone: '',
            isPhone: '0',
            userPhone: '',
            userCountry: '',
            userState: '',
            userCity: '',
            userStreet: '',
            userFloor: '',
            userDepto: '',
            colorPrimary: "#004193",
            colorSecondary: "#00316f",
            colorActive: "#f5f5f5",
            colorAlternative: "#2c2d3f",
            waOpenClose: 'krFdrd',
            waDots: 'showDot',
            waMessage: 'hideMessage',
            timeWa: '',
            flagOpenWa: false,
            btnWa: true,
            userLogoSquare: '',
            userLogoRectangle: '',
            bussinessName: '',
            baseUrl: '',
        }
    },
    mounted: function () { 
        try{
             window.scrollTo(0, 0); 
        }catch(e){

        }

        this.profRef = this.$route.params.ref;
        this.findBussinessData();
        this.findUserInfo();  
        this.getResult();
        this.getResultCourse();
        this.findSocialNetworks();
        this.btnWa = true;
        let url;
        if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
            url = 'https://animasana.net/'
        }else if(window.location.host == 'api-qa.animasana.net'){
            url = 'https://qa.front-ews.pages.dev/' 
        }else{
            url = 'https://qa.front-ews.pages.dev/'
        } 
        url = url + this.$route.params.browserCountry + '/' + this.$route.params.userLang + '/';
        this.baseUrl = url;
    },
    methods:{
        async findBussinessData(){
            var payload = {
                action: 'find-bussiness-data',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef    
            }
            await axios.post('/index.php', payload)
            .then(result => {
                 if(result.data.status == '200'){
                    if(result.data.logoSquare != ''){
                        this.userLogoSquare = result.data.logoSquare;  
                    }
                    if(result.data.logoRectangle != ''){
                        this.userLogoRectangle = result.data.logoRectangle; 
                    }    
                    if(result.data.businessName != ''){   
                        this.bussinessName = result.data.businessName;  
                    }        
                 }  
            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.toastColor = 'bg-danger';
                    this.errorText = 'Revise su conexión de internet.';
                    var toast = new Toast(this.$refs.el)
                    toast.show()	
                    return;
                })
        },
        async findSocialNetworks(){
            var payload = {
                    action: 'find-user-social-networks',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    dataReceiver: this.profRef     
                } 
                await axios.post('/index.php', payload)
                .then(result => {   
                    if(result.data.status == '200'){
                        if(result.data.userFacebook != ''){
                            this.userFacebook = result.data.userFacebook;   
                        }
                        if(result.data.userInstagram != ''){
                            this.userInstagram = result.data.userInstagram;   
                        }
                        if(result.data.userLinkedIn != ''){
                            this.userLinkedIn = result.data.userLinkedIn;   
                        }
                        if(result.data.userTwitter != ''){
                            this.userTwitter = result.data.userTwitter; 
                        } 
                        if(result.data.userTikTok != ''){
                            this.userTikTok = result.data.userTikTok;
                        } 
                        if(result.data.userYouTube != ''){ 
                            this.userYouTube = result.data.userYouTube;
                        }
                        if(result.data.userTwitch != ''){
                            this.userTwitch = result.data.userTwitch;
                        }
                        if(result.data.userWeb != ''){
                            this.userWeb = result.data.userWeb;    
                        }  
                     }    
                });
        },
        async getResult(){
            try{
                var myDiv = document.querySelector('.filter-c-desk');
                myDiv.scrollTop = 0;
            }catch(e){
            }
            this.fromResult = 0;
            this.arrayResTherapies = [];
            var payload = {
                action: 'search-seller-publish-landing',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                search: this.profRef,
                paginate: this.fromResult   
            }
            await axios.post('/index.php', payload).then(result => { 
                let sum = 0;
                Object.keys(result.data).forEach(key => {
                    this.arrayResTherapies.unshift(result.data[sum]);
                    sum++;                        
                });
                this.fromResult = this.fromResult + sum;
                if(this.fromResult > 0){
                    this.getFilters(term, type);
                }
                
            })
            .catch(error => {
                return;
            })
        },
        
        async getResultCourse(){
            try{
                var myDiv = document.querySelector('.filter-c-desk');
                myDiv.scrollTop = 0;
            }catch(e){
            }
            this.fromResultCourse = 0;
            this.arrayResTherapies = [];
            var payload = {
                action: 'search-seller-publish-landing',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                search: this.profRef,
                paginate: this.fromResultCourse,
                publishType: 2         
            }
            await axios.post('/index.php', payload).then(result => { 
                let sum = 0;
                Object.keys(result.data).forEach(key => {
                    this.arrayResCourse.unshift(result.data[sum]);
                    sum++;                        
                });
                this.fromResultCourse = this.fromResultCourse + sum;
                if(this.fromResultCourse > 0){
                    this.getFilters(term, type);
                }
                
            })
            .catch(error => {
                return;
            })
        },
        async findUserInfo(){
            
            var payload = {
                action: 'find-user-info',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef    
            }
            
            await axios.post('/index.php', payload)
            .then(result => {
                 if(result.data.status == '200'){
                    this.profName = result.data.userFirstName;
                    this.profLastName = result.data.userLastName;
                    if(result.data.userImg != ''){
                        this.profImg = result.data.userImg;
                    } 
                    this.findInfoWeb();   
                    this.findUserBio();      
                 }  
            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }	
                    return;
                })
        },
        async findInfoWeb(){
            var payload = {
                action: 'get-info-web-user',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef    
            }
            await axios.post('/index.php', payload)
            .then(result => {
                 if(result.data.status == '200'){
                    if(result.data.error != '1'){ 
                        this.ref = result.data.ref;
                        if(result.data.checkBio == 1){
                            this.bioCheck = true;
                        }else{
                            this.bioCheck = false;
                        }
                        if(result.data.phoneCkeck == 1){
                            this.phoneCheck = true;
                        }else{
                            this.phoneCheck = false;
                        }
                        if(result.data.emailCkeck == 1){
                            this.mailCheck = true;
                        }else{
                            this.mailCheck = false;
                        }
                        if(result.data.addressCkeck == 1){
                            this.addressCheck = true;
                        }else{
                            this.addressCheck = false;
                        }
                        if(result.data.phone != ""){
                            this.phone = result.data.phone;
                            this.userPhone = result.data.phone;
                        }
                        if(result.data.email != ""){
                            this.userMail = result.data.email;  
                        }
                        if(result.data.countryCode != 0){
                            this.userCountry = result.data.countryName;
                            this.userState = result.data.stateName;
                            this.userCity = result.data.cityName;
                            this.userStreet = result.data.street;
                            this.userFloor = result.data.floor;
                            this.userDepto = result.data.depto;
                        }
                        if(result.data.colorPrimary != ""){
                            this.colorPrimary = result.data.colorPrimary;
                            this.colorSecondary = result.data.colorSecondary;
                            this.colorActive = result.data.colorActive;
                            this.colorAlternative = result.data.colorAlternative;
                        } 
                        this.urlName = result.data.url;
                    } 
                 } 
                 
            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.errorText = 'Revise su conexión de internet.1';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }			
                    return;
                })
        },  
        async findUserBio(){
            var payload = {
                action: 'find-user-bio',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef    
            }
            await axios.post('/index.php', payload)
            .then(result => {
                 if(result.data.status == '200'){
                    if(result.data.description != ''){
                        this.infoBio = result.data.description;   
                    }   
                 }  
            })
            .catch(error => {
                    this.loading = false;
                    this.disabled = false;
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }	
                    return;
                })
        }, 
        openWa(){
            this.waOpenClose = 'gAklKS';
            var e = this
            try{
                setTimeout(() => {
                    e.waDots = 'hideDot';
                    e.waMessage = 'showMessage';
                }, "3000");
                this.waDots = e.waDots;
                this.waMessage = e.waMessage;
                this.timeWa = moment().format("HH:mm");
                this.flagOpenWa = true;
            }catch(e){
            }         
        },
        closeWa(){
            this.waOpenClose = 'krFdrd';
        },
        /*tartMessage(){
            var e = this
            try{
                setTimeout(() => {
                    if(e.flagOpenWa == false){
                        e.waOpenClose = 'gAklKS';
                    }
                }, "20000");
                this.waOpenClose = e.waOpenClose;   
                try{
                    setTimeout(() => {           
                        e.waDots = 'hideDot';
                        e.waMessage = 'showMessage';   
                    }, "23000");
                    this.waDots = e.waDots;
                    this.waMessage = e.waMessage;
                    this.timeWa = moment().format("HH:mm");      
                }catch(e){
                }
            }catch(e){
            }        
        }*/
    }
}
</script>
<style>
.img-logo-rectangle{
    width: 80%;
    max-width: 200px;
    transform: translateY(-50px);
}
.img-logo-square{
    width: 140px;
    max-width: 140px;
    transform: translateY(-50px);
}
.user-social{
    border-radius: 50%;
    width: 38px;
    padding: 6px;
    height: 38px;
    margin: 0 2px;
    border-color: v-bind(colorPrimary);
    background-color: v-bind(colorPrimary);
    display: inline-block;
}
.user-social:hover{
    background-color: v-bind(colorSecondary);
    border-color: v-bind(colorSecondary);
}

.user-social:hover img{
    filter: invert(0) !important;
}
#publishTherapy .paused{
    padding: inherit;
    text-align: center;
    text-transform: inherit;
    font-weight: 500;
    position: sticky;
    color: inherit;
}
#publishTherapy .hero-section1 .overlay, #publishTherapy .banner-section .overlay{
    background: v-bind(colorPrimary);
}
#publishTherapy .section-title h3::after{
    background: v-bind(colorPrimary);
}
.result-search .results-c .card .details{
    background-color: v-bind(colorActive);
}
#publishTherapy .section-title h3{
    color: v-bind(colorAlternative);
}
@media (min-width: 576px) {
    * {
        scrollbar-width: thin;
        scrollbar-color: v-bind(colorPrimary) #e6e6e6 !important;
    }
}

</style>
<style scoped>
.user-social {
    border-radius: 50% !important;
    padding: 6px !important;
    display: inline-block !important;
}
/* whatsapp */
main .wa-container{
    display: block !important;
}
.wa-container .lbvXTF {
    position: fixed;
    z-index: 99999999;
    margin: 20px;
    inset: auto 0px 0px auto;
}   
.wa-container .euBiGU {
    position: relative;
    height: fit-content;
    width: fit-content;
    max-width: 100%;
    padding: 0px;
    line-height: 1.32;
    cursor: pointer;
    box-sizing: border-box;
    background: none;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    border-style: solid;
    border-radius: 100px;
    border-color: rgba(0, 0, 0, 0);
    color: rgb(255, 255, 255);
    font-family: inherit;
    font-weight: bold;
    background-color: rgb(0, 201, 98);
    border-width: 0px;
    display: block;
}
.wa-container .euBiGU::before, .gnjhpp::after {
    content: "";
    position: absolute;
    border: 1px solid rgb(0, 201, 98);
    inset: -2px;
    border-radius: 500px;
    opacity: 0;
    z-index: 0;
}
.wa-container .euBiGU::after {
    content: "";
    position: absolute;
    border: 1px solid rgb(0, 201, 98);
    inset: -2px;
    border-radius: 500px;
    opacity: 0;
    z-index: 0;
}
.wa-container .cjTloD {
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    box-sizing: border-box;
    width: 60px;
    height: 60px;
    padding: 16px;
    border-radius: calc(100px);
    background-color: rgba(0, 0, 0, 0);
}
.wa-container .hnfPJG .cjTloD {
    width: 100%;
    height: initial;
}
.wa-container .gnjhpp .cjTloD {
    font-size: 40px;
}
.wa-container .asGVT {
    width: 32px;
    height: 32px;
}
.wa-container .asGVT > div {
    width: inherit;
    height: inherit;
}
.wa-container .asGVT img, .asGVT i {
    display: block;
    -o-object-fit: contain;
    object-fit: contain;
    width: 40px;
    height: 40px;
    fill: currentcolor;
    font-size: 38px;
    margin-left: -3px;
    margin-top: -3px;
}
.wa-container .gnjhpp {
    box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 12px 0px;
    position: relative;
}
.wa-container .dqiKFy {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.wa-container .hKWkLV {
    width: 10px;
    height: 10px;
    background-color: rgb(255, 0, 0);
    position: absolute;
    z-index: 1;
    border-radius: 50%;
    right: 4px;
    top: 4px;
    display: block !important;
}
.wa-container .jLHpcH {
    display: inline-block;
    position: fixed;
    bottom: 0px;
    z-index: 9999999;
    right: 0px;
    left: auto;
}
.wa-container .krFdrd {
    display: block;
    width: 100%;
    border-radius: 16px;
    opacity: 0;
    pointer-events: none;
    touch-action: none;
    visibility: hidden;
    transform: translate3d(0px, 0px, 0px);
    margin-right: 20px;
    margin-bottom: 60px;
    background-color: rgb(255, 255, 255);
    transition: opacity 0.3s ease 0s, margin 0.3s ease 0s, visibility 0.3s ease 0s;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 12px 24px 0px;
    left: auto;
    position: fixed;
    bottom: 0px;
    right: 0px;
    width: 300px;
}
.wa-container .gAklKS {
    display: block;
    width: 100%;
    border-radius: 16px;
    transform: translate3d(0px, 0px, 0px);
    margin-right: 20px;
    margin-bottom: 92px;
    background-color: rgb(255, 255, 255);
    transition: opacity 0.3s ease 0s, margin 0.3s ease 0s, visibility 0.3s ease 0s;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 12px 24px 0px;
    left: auto;
    position: fixed;
    bottom: 0px;
    right: 0px;
    opacity: 1;
    pointer-events: all;
    visibility: visible;
    touch-action: auto;
    width: 300px;
}
.wa-container .bqmPag {
    border-radius: 16px;
    overflow: hidden;
}
.wa-container .bHDPhi {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 20px;
    height: 20px;
    opacity: 0.4;
    cursor: pointer;
    transition: all 0.3s ease 0s;
    outline: transparent;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    display: flex !important;
}
.wa-container .bHDPhi::before, .bHDPhi::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 2px;
    background-color: rgb(17, 17, 17);
    display: block;
    border-radius: 2px;
}
.wa-container .bHDPhi::before {
    transform: rotate(45deg);
}
.wa-container .bHDPhi::after {
    transform: rotate(-45deg);
}
.wa-container .fwCjK {
    background: rgb(255, 255, 255);
    color: rgb(17, 17, 17);
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    padding: 24px 20px;
}
.wa-container .fSqrex {
    position: relative;
    width: 52px;
    height: 52px;
    box-shadow: rgba(17, 17, 17, 0.1) 0px 0px 2px inset;
    border-radius: 50%;
    overflow: hidden;
}
.wa-container .kFAyCA {
    display: block;
    flex-shrink: 0;
    overflow: inherit;
    cursor: pointer;
}
.wa-container .kFAyCA::before {
    content: "";
    bottom: 0px;
    right: 0px;
    width: 12px;
    height: 12px;
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
    border-radius: 50%;
    background-color: rgb(74, 213, 4);
    display: block;
    border: 2px solid rgb(255, 255, 255);
}
.wa-container .fSqrex::after {
    content: "";
    position: absolute;
    top: 0px;
    display: block;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    box-shadow: rgba(17, 17, 17, 0.1) 0px 0px 2px inset;
}
.wa-container .gJOYgw {
    width: inherit;
    height: inherit;
    transition: opacity 1s ease-out 0s;
    background-color: rgb(210, 210, 210);
    opacity: 1;
    border-radius: 50%;
    overflow: hidden;
}
.wa-container .UobXQ {
    display: inline-block !important;
    position: static !important;
    margin: 0px !important;
    padding: 0px !important;
    max-width: none !important;
    height: inherit !important;
    width: inherit !important;
    visibility: visible !important;
    max-width: 46px !important;
}
.wa-container .kFAyCA img {
    object-fit: cover;
}
.wa-container .kRqifD {
    margin-left: 16px;
    margin-right: 16px;
    width: 100%;
    overflow: hidden;
}
.wa-container .hgwDJP {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    max-height: 60px;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: rgb(17, 17, 17);
}
.wa-container .coXmzM {
    font-size: 13px;
    line-height: 18px;
    margin-top: 4px;
    color: rgb(17, 17, 17);
}
.wa-container .czJZmb {
    padding: 20px 20px 20px 10px;
    background-color: rgb(230, 221, 212);
    position: relative;
    overflow: auto;
    max-height: 382px;
}
.wa-container .czJZmb::before {
    display: block;
    position: absolute;
    content: "";
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    z-index: 0;
    opacity: 0.08;
    background-image: url(https://static.elfsight.com/apps/all-in-one-chat/patterns/whatsapp.png);
}
.wa-container .chJVkN {
    display: flex;
    z-index: 1;
}
.wa-container .dcUHJP {
    background-color: rgb(255, 255, 255);
    width: 52.5px;
    height: 32px;
    border-radius: 16px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin-left: 10px;
    opacity: 0;
    transition: all 0.1s ease 0s;
    z-index: 1;
    box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
}
.wa-container .dcUHJP.hideDot {
    opacity: 0;
}
.wa-container .dcUHJP.showDot {
    opacity: 1;
}
.wa-container .ZSLkz {
    position: relative;
    display: flex;
}

.wa-container .iAzjNW {
    height: 5px;
    width: 5px;
    margin: 0px 2px;
    background-color: rgb(182, 181, 186);
    border-radius: 50%;
    position: relative;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    top: 0px;
    display: inline-block !important;
}
.wa-container .eoQXKa {
    background-color: rgb(158, 157, 162);
    animation-name: dJHihm;
}
.wa-container .jVsCox {
    animation-name: goHzKU;
}
.wa-container .gRVhYZ {
    animation-name: krEmjx;
}

.wa-container .drCIHo {
    box-sizing: border-box;
    padding: 7px 14px 6px;
    position: relative;
    transition: all 0.3s ease 0s;
    opacity: 0;
    transform-origin: center top;
    z-index: 2;
    margin-left: -54px;
    color: rgb(17, 17, 17);
    font-size: 15px;
    line-height: 1.39;
    max-width: calc(100% - 66px);
    border-radius: 0px 8px 8px;
    background-color: rgb(255, 255, 255);
    margin-top: 4px;
}
.wa-container .drCIHo.hideMessage{
    opacity: 0;
}
.wa-container .drCIHo.showMessage{
    opacity: 1;
}
.wa-container .drCIHo::before {
    position: absolute;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAMAAADp2asXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACQUExURUxpccPDw9ra2m9vbwAAAAAAADExMf///wAAABoaGk9PT7q6uqurqwsLCycnJz4+PtDQ0JycnIyMjPf3915eXvz8/E9PT/39/RMTE4CAgAAAAJqamv////////r6+u/v7yUlJeXl5f///5ycnOXl5XNzc/Hx8f///xUVFf///+zs7P///+bm5gAAAM7Ozv///2fVensAAAAvdFJOUwCow1cBCCnqAhNAnY0WIDW2f2/hSeo99g1lBYT87vDXG8/6d8oL4sgM5szrkgl660OiZwAAAHRJREFUKM/ty7cSggAABNFVUQFzwizmjPz/39k4YuFWtm55bw7eHR6ny63+alnswT3/rIDzUSC7CrAziPYCJCsB+gbVkgDtVIDh+DsE9OTBpCtAbSBAZSEQNgWIygJ0RgJMDWYNAdYbAeKtAHODlkHIv997AkLqIVOXVU84AAAAAElFTkSuQmCC);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    top: 0px;
    left: -12px;
    width: 12px;
    height: 19px;
}
.wa-container .TZMBk {
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.4);
}
.wa-container .fPKXxD {
    font-size: 14px;
    line-height: 19px;
    margin-top: 4px;
    color: rgb(17, 17, 17);
}
.wa-container .TGVsQ {
    text-align: right;
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    color: rgba(17, 17, 17, 0.5);
    margin-right: -8px;
    margin-bottom: -4px;
}
.wa-container .hnfPJG {
    backface-visibility: hidden;
    overflow: hidden;
}
@keyframes goHzKU {
    15% {
        background-color: rgb(182, 181, 186);
    }
    25% {
        background-color: rgb(17, 17, 17);
    }
    35% {
        background-color: rgb(182, 181, 186);
    }
}
@keyframes dJHihm {
    0% {
        background-color: rgb(182, 181, 186);
    }

    15% {
        background-color: rgb(17, 17, 17);
    }

    25% {
        background-color: rgb(182, 181, 186);
    }
}
@keyframes krEmjx {
    25% {
        background-color: rgb(182, 181, 186);
    }

    35% {
        background-color: rgb(17, 17, 17);
    }

    45% {
        background-color: rgb(182, 181, 186);
    }
}
/* fin whatsapp */
</style>